export default {
  title: '产品分类',
  addFirstLevel: '新增一级分类',
  addSecondLevel: '新增二级分类',
  categoryName: '分类名称',
  addModal: '新增一级分类',
  editModal: '编辑分类',
  addSecondModal: '新增二级分类',
  required: '请输入分类名称',
};
